import { render } from "./Head.vue?vue&type=template&id=58d7c2e8"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"
script.render = render

export default script